/**
 * The API client, passed through context rather than imported directly.
 *
 * One reason, and it is a testing reason with a design consequence: a
 * component that imports a module-level client cannot be rendered against a
 * fake one without module mocking, and module mocking is how a test ends up
 * asserting against a shape nobody promised. Context makes the client an
 * argument, so `renderRoute` in `src/testing/` hands components a client built
 * from a stub `fetch` — the same generated client the browser uses, over a
 * different transport.
 */

import { createContext, useContext } from 'react';
import type { Client } from '@davinci/contracts';

const ApiContext = createContext<Client | undefined>(undefined);

export const ApiProvider = ApiContext.Provider;

export function useApi(): Client {
  const api = useContext(ApiContext);
  if (api === undefined) {
    throw new Error('useApi was called outside ApiProvider — see src/app/providers.tsx.');
  }
  return api;
}
